import CompanyDetailPage from "./CompanyDetailPage";
import AdminStateGroupDetailPage from "./AdminStateGroupDetailPage";

export default class RegionalCompanyDetailPage extends CompanyDetailPage {
  static PageInfo = {
    
    parent: AdminStateGroupDetailPage,
    path: "/Admin/StateGroup/:state/Company/:id",
    name: "menu.franchisee", 
    permission: { "COMPANY_ACCESSING": true },
    hidden:true,
    icon: "store"
  }
}  